import { AxiosRequestConfig } from 'axios';

export default {
    getData: (data: Array<any>) =>
        ({ method: 'POST', url: `/data-retrieval/retrieval/legacy`, data } as AxiosRequestConfig),
};
